import React from 'react';
import {Dialog} from "primereact/dialog";
import getLabel from '../../services/LinkagesDataLayer/labels';
import LinkagesDataLayerService from "../../services/LinkagesDataLayer/LinkagesDataLayerService";
import './estilos.css';
import {Column} from "primereact/column";
import { DataTable } from 'primereact/datatable';

const propertiesDictionatary = {
    'trabalhador' : [
        'ano',
        'agricultura',
        'taxa_agricultura',
        'industrias_extrativas',
        'taxa_industrias_extrativas',
        'industrias_transformacao',
        'taxa_industrias_transformacao',
        'eletricidade_gas',
        'taxa_eletrecidade_gas',
        'agua_esgoto_residuos',
        'taxa_agua_esgoto_residuos',
        'construcao',
        'taxa_construcao',
        'comercio_veiculos',
        'taxa_comercio_veiculos',
        'transporte_armazenagem',
        'taxa_transporte_armazenagem',
        'alojamento_alimentacao',
        'taxa_alojamento_alimentacao',
        'informacao_comunicacao',
        'taxa_informacao_comunicacao',
        'atividades_financeiras',
        'taxa_atividades_financeiras',
        'atividades_imobiliarias',
        'taxa_atividades_imobiliarias',
        'atividades_profissionais_cien_tec',
        'taxa_atividades_profissionais_cien_tec',
        'atividades_administrativas',
        'taxa_atividades_administrativas',
        'administracao_publica',
        'taxa_administracao_publica',
        'educacao',
        'taxa_educacao',
        'saude_servicos_sociais',
        'taxa_saude_servicos_sociais',
        'artes_recreacao',
        'taxa_artes_recreacao',
        'outros',
        'taxa_outros',
        'servicos_domesticos',
        'taxa_servicos_domesticos',
        'org_internacionais',
        'taxa_org_internacionais',
        'total',
    ],
    'expansao_urbana' : [
        'ano',
        'area',
        'crescimento_percentual',
        'area_total_km2',
        'sigla_uf',
    ],
    'area_urbanizada': [
        'ano',
        'area_total_km2',
    ],
    'dutovias': [
        'fonte',
        'nome_dutovia',
        'categoria',
        'distribuidora',
        'tipo_dutovia',
    ],
    'vazios_urbanos': [
        'nm_municipio',
        'area_km2',
    ],
    'area_preservacao': [
        'tipo',
        'nome',
    ]

};

class LinkagesDataDictionaryModal extends React.Component {

    constructor(props) {
        super(props);
        const options = LinkagesDataLayerService.getAvailableLayers();
        let activeDataLayer = 'renda';
        let properties = [];

        if( props.activeDatalayer ){
            activeDataLayer = props.activeDatalayer;
        }

        this.state = {
            dictionary: [],
            options: options,
            activeDatalayer: activeDataLayer,
            properties: properties
        }
    }

    componentDidMount = async () => {
        await this.loadDictionary();
    }

    loadDictionary = async () => {
        try {
            const response = await LinkagesDataLayerService.getDataDictionary();
            if (response && response.data) {
                this.setState({dictionary: response.data});
            }
        } catch (error) {
            console.error(error);
        }
    }

    getProperties = (option) => {
        let properties = LinkagesDataLayerService.getPropertiesForColorMap(option);

        let specialCases = ['trabalhador', 'expansao_urbana', 'area_urbanizada', 'vazios_urbanos', 'dutovias', 'area_preservacao'];


        if( specialCases.includes(option) ){
            properties = propertiesDictionatary[option];
        }

        if( properties && properties.length > 0 ){
            properties = properties?.map(prop => {
                let property = prop;
                if( prop.includes("|")){
                    property = prop.split('|')[1];
                }
                /**
                 * {
                 *         "tema": "zoneamento",
                 *         "nome_no_banco": "sigla_zoneamento",
                 *         "descricao": "sigla do zoneamento"
                 *     },
                 */
                let descricao = this.state.dictionary.find( item => item.nome_no_banco === property );

                return {
                    label: getLabel(property),
                    value: property,
                    description: descricao ? descricao.descricao : '',
                };
            })
        }

        return properties;
    }

    handleChangeDatalayer = async (option) => {
        await this.setState({
            ...this.state,
            activeDatalayer: option,
        });
    }

    render() {

        let properties = this.getProperties(this.state.activeDatalayer);

        return (<React.Fragment>
            <Dialog header="Dicionário de dados" visible={this.props.visible}
                    style={{width: '70vw', marginTop: '30px'}} onHide={this.props.onHide}>
                <div className="card" id="data-dictionary-container" style={{
                    maxHeight: '75vh',
                    minHeight: '50vh',
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    marginBottom: '20px'
                }}>
                    <div className="card-body" style={{overflowX: 'scroll'}}>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-3">
                                    <ul className="list-unstyled">
                                        {this.state.options.map( option => {
                                            return (
                                                <li key={option.group}>
                                                    <span className="font-weight-bold">
                                                        {option.group}
                                                    </span>
                                                    <ul className="list-unstyled" style={{
                                                        marginLeft: '20px',
                                                    }}>
                                                        {option.options.map( o => {
                                                            return (
                                                                <li key={o.value} className="">
                                                                    <a onClick={async (e)=>{
                                                                        e.preventDefault();
                                                                        await this.handleChangeDatalayer(o.value);
                                                                    }}
                                                                       className="btn-link btn-link-seletor"
                                                                       href="#" >
                                                                        {o.label}
                                                                    </a>
                                                                </li>
                                                            )
                                                        })}
                                                    </ul>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </div>
                                <div className="col-9">
                                    <div className="card">
                                        <h5>{this.props.datalayerName}</h5>
                                        <DataTable value={properties} scrollable scrollHeight="500px">
                                            <Column field="label" header="Variável"></Column>
                                            <Column field="description" header="Descrição"></Column>
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        </React.Fragment>);
    }
}

LinkagesDataDictionaryModal.defaultProps = {
    visible: false,
    data: [],
    columns: [],
    datalayerLabel: 'Datalayer',
    onHide: () => {
    }
}


export default LinkagesDataDictionaryModal;
